import React from 'react'
import NumberFormat from 'react-number-format'
import { DisplayToThaiDateFormat } from '../../helpers/texthelper'
import { DocumentDetailModel } from '../../models/documentDetail'

export const ChequeDetail: React.FC<{ item: DocumentDetailModel }> = ({ item }) => {
  return (
    <>
      <div className="flex-container">
        <div className="flex-item-left">
          <div className="flex-container-cc">
            <div className="flex-item-cc-left">
              <li>
                <span>{item.paymentMethod.name}</span>{' '}
              </li>
            </div>
          </div>
          <div className="flex-container-cashPayIn-detail">
            <div className="flex-item-detail-right">
              เลขที่เช็ค : <span>{item.cheque_Number}</span>{' '}
            </div>
            <div className="flex-item-detail-left">
              เช็คลงวันที่ : <span>{DisplayToThaiDateFormat(new Date(item.cheque_Date))}</span>
            </div>
            <div className="flex-item-detail-right">
              ธนาคารเจ้าของเช็ค : <span>{item.cheque_Bank}</span>
            </div>
            <div className="flex-item-detail-left">
              สาขาธนาคารเจ้าของเช็ค : <span>{item.cheque_Branch}</span>
            </div>

            <div className="flex-item-detail-left">
              จำนวนเงินตามหน้าเช็ค :{' '}
              <span>
                <NumberFormat
                  thousandsGroupStyle="thousand"
                  value={item.paymentTotalAmount}
                  prefix=""
                  decimalSeparator="."
                  displayType="text"
                  type="text"
                  thousandSeparator={true}
                  allowNegative={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </span>{' '}
              บาท
            </div>
            {/* 
            <div className="flex-item-detail-right">
              Pay in to Bank : <span>{item.payInToBank}</span>
            </div>
            <div className="flex-item-detail-left">
              ธนาคาร : <span>{getBankName(item.bankCode)}</span>
            </div>
            <div className="flex-item-detail-right">
              Account No. : <span>{item.accountNo}</span>
            </div> */}
          </div>
        </div>
        <div className="flex-item-right amount-right">
          <span>
            <NumberFormat
              thousandsGroupStyle="thousand"
              value={item.paymentAmount}
              prefix=""
              decimalSeparator="."
              displayType="text"
              type="text"
              thousandSeparator={true}
              allowNegative={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </span>{' '}
          บาท
        </div>
      </div>
      {/* <ReceiptList documentDetail={item} />
      <hr className="separate-detail"></hr> */}
    </>
  )
}
